import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PRODUCTS_BY_SKUS } from '../operations/queries/get-products-by-skus.js';

const mapResultToProducts = (data)=>{
    const products = data === null || data === void 0 ? void 0 : data.getProductsBySKUs;
    if (!products) {
        return;
    }
    return products.flatMap((product)=>{
        return product.variants.map((variant)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            const image = variant.media.images[0];
            var _label;
            return {
                __itemType: 'product',
                name: product.name,
                slug: product.slug,
                sku: variant.sku,
                price: {
                    amount: ((ref = variant.prices.discountedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.amount) || ((ref2 = variant.prices.originalPrice) === null || ref2 === void 0 ? void 0 : ref2.amount),
                    currencyCode: ((ref3 = variant.prices.discountedPrice) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.price) === null || ref4 === void 0 ? void 0 : ref4.currencyCode) || ((ref5 = variant.prices.originalPrice) === null || ref5 === void 0 ? void 0 : ref5.currencyCode)
                },
                image: image ? {
                    url: image.url,
                    dimensions: {
                        width: image.dimensions.w,
                        height: image.dimensions.h
                    },
                    label: (_label = image.label) !== null && _label !== void 0 ? _label : undefined
                } : null
            };
        });
    });
};
const useProducts = ()=>{
    const [query, { called , data , error: error1 , loading  }] = useLazyQuery(GET_PRODUCTS_BY_SKUS, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed('tryInStore.component.selectionModal.fetchError');
        }
    });
    const trigger = React.useCallback((skus)=>{
        query({
            variables: {
                skus
            }
        });
    }, [
        query
    ]);
    const state = React.useMemo(()=>({
            called,
            data: mapResultToProducts(data),
            error: error1,
            loading
        })
    , [
        called,
        data,
        error1,
        loading
    ]);
    return React.useMemo(()=>[
            trigger,
            state
        ]
    , [
        trigger,
        state
    ]);
};

export { useProducts };
//# sourceMappingURL=use-products.js.map
